import { MenuItem } from "@mui/material";
import { FastField } from "formik";
import BaseInput from "./BaseInput";

const SelectInput = ({...props}) => {
    const {name, options} = props;
    // adding this to the props to change baseInput it into select field
    props.select = true;

    return (
        <FastField name={name}>
            {({ field, form, meta }) => (
                <BaseInput {...{field, form, meta, props}}>
                    <MenuItem value="">Aucune Option</MenuItem>
                    {
                        options?.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))
                    }
                </BaseInput>
            )}
        </FastField>
    );
};

export default SelectInput;